import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import moment from 'moment';
import { manualApi } from '../../api/global';
import { URL } from '../../data/url';
import TrashIc from '../../assets/images/ic_trash.svg';
import ConfirmModal from '../common/ConfirmModal';

function MyTestPaperList({ selectedMyManual = null, myManuals = [] }) {
  const navigate = useNavigate();
  const [testPapers, setTestPapers] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);

  const loadList = useCallback(async () => {
    try {
      const { data } = await manualApi.getTestPaperList({
        bookId: selectedMyManual.idx,
      });
      setTestPapers(data.exams);
    } catch (error) {
      console.log(error);
    }
  }, [selectedMyManual]);

  useEffect(() => {
    (async () => {
      if (!selectedMyManual) return;
      await loadList();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMyManual]);

  const handleLoadTestPaperDetail = useCallback(
    async paperId => {
      try {
        if (!selectedMyManual) return;
        const { data } = await manualApi.getTestPaperDetail(paperId);
        navigate(URL.Vocabulary, {
          state: { manual: selectedMyManual, myManuals, testPaper: data.exam },
        });
      } catch (error) {
        console.log(error);
      }
    },
    [selectedMyManual, myManuals, navigate],
  );

  const handleDeleteTestPaper = useCallback(async () => {
    try {
      if (!deleteModalOpen) return;
      const { data, status } = await manualApi.removeTestPaper(deleteModalOpen);
      if (status === 200 && data.message === 'Success') {
        setDeleteModalOpen(null);
        loadList();
      }
    } catch (error) {
      console.log(error);
    }
  }, [deleteModalOpen, loadList]);

  return (
    <div className="border border-[14px] border-[#CBD5E1] w-full h-full flex flex-col items-start justify-start">
      <div className="w-full h-full p-[14px] border-[15px] border-[#F1F5F9]">
        {selectedMyManual === null ? (
          <div className="w-full h-full flex justify-center items-center text-[#383C4B] font-[16px] font-[400]">
            교재를 선택해주세요.
          </div>
        ) : (
          <div className="w-full h-full flex flex-col justify-start items-start p-[14px] bg-[#fff]">
            <div className="w-full min-h-[38px] mb-[30px] flex justify-between items-center text-[#383C4B] font-[16px] font-[400]">
              <div className="text-[24px]">
                <span className="font-[700]">
                  {selectedMyManual?.book_title}&nbsp;교재
                </span>
                의 저장한 시험지 목록
              </div>
              <Button
                variant="contained"
                sx={{
                  p: '4px 14px',
                  width: '220px',
                  height: '76px',
                  fontSize: '24px',
                }}
                onClick={() =>
                  navigate(URL.Vocabulary, {
                    state: { manual: selectedMyManual, myManuals },
                  })
                }
              >
                새 시험지 제작
              </Button>
            </div>
            {testPapers?.length >= 1 ? (
              <>
                <div className="h-[40px] w-full px-[14px] grid grid-cols-[1fr_8fr_3fr_2fr_3fr_1fr] items-center bg-[#F1F5F9] border-b border-[#E2E8EF] text-[#A9B6CA] text-[12px]">
                  <div className="flex justify-center">No.</div>
                  <div className="flex justify-center">제목</div>
                  <div className="flex justify-center">출제범위</div>
                  <div className="flex justify-center">문항수</div>
                  <div className="flex justify-center">저장일시</div>
                  <div />
                </div>
                <div className="w-full max-h-[800px] overflow-y-auto">
                  {testPapers?.length >= 1 &&
                    testPapers?.map((paper, index) => {
                      return (
                        <div
                          key={paper.id}
                          className="h-[40px] w-full px-[14px]  grid grid-cols-[1fr_8fr_3fr_2fr_3fr_1fr] items-center border-b border-[#E2E8EF] overflow-y-hidden text-[14px] font-[400]"
                        >
                          <div
                            className="flex justify-center cursor-pointer"
                            onClick={() => handleLoadTestPaperDetail(paper.id)}
                          >
                            {index + 1}
                          </div>
                          <div
                            className="flex justify-center cursor-pointer"
                            onClick={() => handleLoadTestPaperDetail(paper.id)}
                          >
                            {paper.examName}
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleLoadTestPaperDetail(paper.id)}
                            style={{
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              wordBreak: 'break-word',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              textAlign: 'center',
                            }}
                          >
                            {typeof paper?.unitNames === 'string'
                              ? ''
                              : paper?.unitNames?.map((name, index) => {
                                  return index === paper?.unitNames?.length - 1
                                    ? name
                                    : name + ', ';
                                })}
                          </div>
                          <div
                            className="flex justify-center cursor-pointer"
                            onClick={() => handleLoadTestPaperDetail(paper.id)}
                          >
                            {paper.questionsCount}
                          </div>
                          <div
                            className="flex justify-center cursor-pointer"
                            onClick={() => handleLoadTestPaperDetail(paper.id)}
                          >
                            {paper?.createdAt
                              ? moment
                                  .utc(paper?.createdAt)
                                  .local()
                                  .format('YYYY.MM.DD HH:mm')
                              : moment
                                  .utc(paper?.updatedAt)
                                  .local()
                                  .format('YYYY.MM.DD HH:mm')}
                          </div>
                          <button
                            type="button"
                            className="flex justify-center"
                            onClick={() => setDeleteModalOpen(paper.id)}
                          >
                            <img src={TrashIc} alt="delete" />
                          </button>
                        </div>
                      );
                    })}
                </div>
              </>
            ) : (
              <>
                <div className="w-full h-full flex justify-center items-center text-[#383C4B] font-[16px] font-[400]">
                  저장한 시험지가 없습니다.
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <ConfirmModal
        open={deleteModalOpen !== null ? true : false}
        setOpen={setDeleteModalOpen}
        content={`저장한 시험지가 삭제됩니다.\n정말 삭제하시겠습니까?`}
        cancelLabel="취소"
        confirmLabel="삭제"
        onCancel={() => {}}
        onConfirm={handleDeleteTestPaper}
      />
    </div>
  );
}

MyTestPaperList.propTypes = {
  selectedMyManual: PropTypes.object,
  myManuals: PropTypes.arrayOf(PropTypes.object),
};

export default React.memo(MyTestPaperList);
